import React from 'react'

const DMA = () => {
    return (
        <div className='container'>
            <h1>C Dynamic Memory Allocation</h1>
            <div className='containers'>
            As you know, an array is a collection of a fixed number of values. Once the size of an array is declared, you cannot change it. <br />
<br />
Sometimes the size of the array you declared may be insufficient. To solve this issue, you can allocate memory manually during run-time. This is known as dynamic memory allocation in C programming. <br />
<br />
To allocate memory dynamically, library functions are malloc(), calloc(), realloc() and free() are used. These functions are defined in the &lt;stdlib.h&gt; header file. <br />

            </div>
            <h3>C malloc()</h3>
            he name "malloc" stands for memory allocation. <br />
<br />
The malloc() function reserves a block of memory of the specified number of bytes. And, it returns a pointer of void which can be casted into pointers of any form. <br />
<h3>Syntax of malloc()</h3>
<div className='containers'>
ptr = (castType*) malloc(size); <br />
Example: <br />
ptr = (float*) malloc(100 * sizeof(float));
</div>
The above statement allocates 400 bytes of memory. It's because the size of float is 4 bytes. And, the pointer ptr holds the address of the first byte in the allocated memory. <br />
<br />
The expression results in a NULL pointer if the memory cannot be allocated. <br />
<h3>C calloc()</h3>
The name "calloc" stands for contiguous allocation. <br />
<br />
The malloc() function allocates memory and leaves the memory uninitialized, whereas the calloc() function allocates memory and initializes all bits to zero. <br />
<h3>Syntax of calloc()</h3>
<div className='containers'>
ptr = (castType*)calloc(n, size); <br />
Example: <br />
ptr = (float*) calloc(25, sizeof(float));<br />
</div>

The above statement allocates contiguous space in memory for 25 elements of type float. <br />
<h3>C free()</h3>
Dynamically allocated memory created with either calloc() or malloc() doesn't get freed on their own. You must explicitly use free() to release the space <br />
<h3>Syntax of free()</h3>
<div className='containers'>
free(ptr); <br />
</div>
This statement frees the space allocated in the memory pointed by ptr.
<h3>C realloc()</h3>
If the dynamically allocated memory is insufficient or more than required, you can change the size of previously allocated memory using the realloc() function.

<h3>Syntax of realloc()</h3>
<div className='containers'>
ptr = realloc(ptr, x);
</div>
Here, ptr is reallocated with a new size x <br />
<h3>Example 1: malloc() and free()</h3>
<div className='containers'>
<code className='comment'>//  Calculate the sum of n numbers entered by the user </code><br />

<code className='library'> #include</code> &lt;stdio.h&gt; <br />
<code className='library'>#include</code> &lt;stdlib.h&gt; <br />
<br />
<code className='keywords'>int </code>main() <br />
&#123; <br />
<code className='keywords'>  int </code>n, i, *ptr, sum = 0; <br />
<br />
<code className='library'> printf</code>("Enter number of elements: "); <br />
<code className='library'> scanf</code>("%d", &n); <br />
<br />
    ptr = (int*)<code className='keywords'> malloc</code>(n * sizeof(int)); <br />
    <br />
    <code className='comment'>// if memory cannot be allocated</code> <br />
    <code className='library'> if</code>(ptr == NULL)                      <br />
    &#123; <br />
    <code className='library'>     printf</code>("Error! memory not allocated."); <br />
    <code className='keywords'>     exit</code>(0); <br />
    &#125; <br />
    <br />
    <code className='library'> printf</code>("Enter elements: "); <br />
    <code className='keywords'> for</code>(i = 0; i &lt; n; ++i) <br />
    &#123; <br />
        scanf("%d", ptr + i); <br />
        sum += *(ptr + i); <br />
    &#125; <br />
    <br />
    <code className='library'> printf</code>("Sum = %d", sum); <br />
    <br />
    <code className='comment'> // deallocating the memory</code> <br />
    <code className='keywords'> free</code>(ptr); <br />
    <br />
    <code className='library'>  return</code> 0; <br />
&#125; <br />
</div>
<h3>Example 2: calloc() and free()</h3>
 <div className='containers'>
 <code className='comment'>// Program to calculate the sum of n numbers entered by the user<br /></code>
 <br />
<code className='library'>#include</code>  &lt;stdio.h&gt;<br />
<code className='library'>#include </code>&lt;stdlib.h&gt;<br />
<br /><br />
<code className='library'>int</code> main()<br />
&#123;<br />
<code className='library'>  int</code> n, i, *ptr, sum = 0;<br />
<code className='library'> printf</code>("Enter number of elements: ");<br /><br />
<code className='library'> scanf</code>("%d", &n);<br />
<br />
    ptr = (int*) calloc(n, sizeof(int));<br />
    <code className='library'>  if</code>(ptr == NULL)<br /><br />
    &#123;
    <code className='library'>  printf</code>("Error! memory not allocated.");<br />
    <code className='library'>  exit</code>(0);<br />
    &#125;<br />
    <br />
    <code className='library'> printf</code>("Enter elements: ");<br />
    <code className='library'> for</code>(i = 0; i &lt; n; ++i)<br />
    &#123;<br />
        scanf("%d", ptr + i);<br />
        sum += *(ptr + i);<br />
    &#125;<br />
    <br />
    <code className='library'>  printf</code>("Sum = %d", sum);<br />
    <code className='library'>  free</code>(ptr);<br />
    <code className='library'> return </code>0;<br />
&#125;<br />
 </div>
        </div>
    )
}

export default DMA
